import { createContext } from 'react';

export const DashboardModalContext = createContext(null);

export const DashboardSSEEventContext = createContext({});

/**
 * Context used to collect PDF-report-ready data from the various dashboard
 * sections. Each Home section registers a compact, display-ready representation
 * of its current data via `registerReportSection(key, payload)`. The collected
 * data is later read by the Export PDF control to build the report.
 */
export const DashboardReportContext = createContext({
    registerReportSection: () => { },
});
